import { Button } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: unset;
`;

export const ColorPreviewButton = styled(Button)`
  align-self: center;
  padding: 0px;
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 1px solid ${tokens.colors.gray};
  margin-left: ${tokens.space.smaller};
  border-radius: ${tokens.radii.s};
`;

export const ResetToDefaultButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border-radius: ${tokens.radii.s};
`;

export const HiddenInputContainer = styled.div`
  position: relative;
`;

export const HiddenColorInput = styled.input`
  visibility: hidden;
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  left: 0;
  top: 27px;
`;
